import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Message } from '@dreryk/react-components';

import { accountConfigurationInfoTranslationKeys } from '../../translations';

enum ConfigurationMessage {
   READY = 'READY',
}

type AccountConfigurationInfoStatusProps = {
   readonly testId: string;
};

export const AccountConfigurationInfoStatus = (props: AccountConfigurationInfoStatusProps): JSX.Element => {
   const theme = useTheme();
   const options = useMemo(
      () => ({
         [ConfigurationMessage.READY]: {
            color: theme.success,
            backgroundColor: theme.successLighter,
         },
      }),
      [theme]
   );

   return (
      <Message
         testId={props.testId}
         type={ConfigurationMessage.READY}
         label={accountConfigurationInfoTranslationKeys.ready}
         options={options}
         displayIndicator
      />
   );
};
